export const isNumber = (n:any)=> { return /^-?[\d.]+(?:e-?\d+)?$/.test(n); }